// ./data/pg_runs_all.js
// Example cached runs for multiple datasets.
// Structure matches what your dashboard expects.

// ./data/pg_runs_all.js
// Example cached runs for multiple datasets.
// Structure matches what your dashboard expects.

// ./data/pg_runs_all.js
// Example cached runs for multiple datasets.
// Structure matches what your dashboard expects.

export const PG_SCHEMA_RUNS = {
  POLE: [
    {
      id: "pole_001",
      ts: 1731332400000, // 2024-11-12T10:00:00Z
      params: {
        dataset: "POLE",
        incremental: false,
        knownTypeLabelPercentage: 100,
        adaptive: true,
        lshHashTables: 20,
        lshHashBucketLength: 4,
        jaccardSimilarityThreshold: 0.75
      },
      summary: { nodeTypes: 4, edges: 4 },
      metrics: {
        nodes: { precision: 0.91, recall: 0.88, f1Score: 0.895 },
        edges: { precision: 0.84, recall: 0.81, f1Score: 0.825 }
      },
      snapshot: {
        nodes: [
          {
            name: "Person",
            looseDetails: [
              { name: "name", type: "string" },
              { name: "age", type: "int" }
            ],
            strictDetails: [
              { name: "id", type: "string", optional: false },
              { name: "name", type: "string", optional: true },
              { name: "age", type: "int", optional: true }
            ]
          },
          {
            name: "Company",
            looseDetails: [
              { name: "name", type: "string" }
            ],
            strictDetails: [
              { name: "id", type: "string", optional: false },
              { name: "name", type: "string", optional: true }
            ]
          },
          {
            name: "City",
            looseDetails: [
              { name: "label", type: "string" }
            ],
            strictDetails: [
              { name: "label", type: "string", optional: true }
            ]
          },
          {
            name: "Project",
            looseDetails: [
              { name: "title", type: "string" }
            ],
            strictDetails: [
              { name: "pid", type: "string", optional: false },
              { name: "title", type: "string", optional: true }
            ]
          }
        ],
        edges: [
          {
            source: "Person",
            target: "Company",
            relationship: "WORKS_AT",
            looseDetails: [
              { name: "since", type: "date" }
            ],
            strictDetails: [
              { name: "cardinality", type: "M->1" } // πολλοί Person σε μία Company
            ]
          },
          {
            source: "Company",
            target: "City",
            relationship: "LOCATED_IN",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" } // πολλές Company σε μία City
            ]
          },
          {
            source: "Person",
            target: "Project",
            relationship: "ASSIGNED_TO",
            looseDetails: [
              { name: "role", type: "string" }
            ],
            strictDetails: [
              { name: "cardinality", type: "M->N" } // πολλοί Person σε πολλά Project
            ]
          },
          {
            source: "Project",
            target: "City",
            relationship: "RUNS_IN",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" } // πολλά Project σε μία City
            ]
          }
        ]
      },
      logs: [
        "[11:00:00] Start PG-HIVE (incremental=500000)",
        "[11:00:03] Merged previous patterns",
        "[11:00:40] Re-clustered 12K items",
        "[11:01:05] Best F1 nodes=0.855 edges=0.76",
        "[11:01:07] Done"
      ],
      _dataset: "POLE"
    },

    {
      id: "pole_002",
      ts: 1731336000000, // 2024-11-12T11:00:00Z
      startTs: 1731336000000,
      pgschema_strict: "",
      pgschema_loose: "",
      xsd: "",
      params: {
        dataset: "POLE",
        incremental: true,
        incrementalValue: 500000,
        knownTypeLabelPercentage: 50,
        adaptive: false,
        lshHashTables: 10,
        lshHashBucketLength: 6,
        jaccardSimilarityThreshold: 0.7
      },
      summary: { nodeTypes: 5, edges: 6 },
      metrics: {
        nodes: { precision: 0.89, recall: 0.82, f1Score: 0.855 },
        edges: { precision: 0.78, recall: 0.74, f1Score: 0.76 }
      },

      // per-iteration results
      iterations: [
        {
          iteration: 1,
          ts: 1731336300000, // 11:05
          metrics: {
            nodes: { precision: 0.80, recall: 0.76, f1Score: 0.78 },
            edges: { precision: 0.73, recall: 0.68, f1Score: 0.70 }
          },
          summary: { nodeTypes: 4, edges: 5 },
          snapshot: {
            nodes: [
              {
                name: "Person",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "name", type: "string", optional: true }
                ]
              },
              {
                name: "Company",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "name", type: "string", optional: true }
                ]
              },
              {
                name: "Project",
                looseDetails: [
                  { name: "title", type: "string" }
                ],
                strictDetails: [
                  { name: "title", type: "string", optional: true }
                ]
              },
              {
                name: "City",
                looseDetails: [
                  { name: "label", type: "string" }
                ],
                strictDetails: [
                  { name: "label", type: "string", optional: true }
                ]
              }
            ],
            edges: [
              {
                source: "Person",
                target: "Company",
                relationship: "WORKS_AT",
                looseDetails: [
                  { name: "since", type: "date" }
                ],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Company",
                target: "City",
                relationship: "LOCATED_IN",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Person",
                target: "Project",
                relationship: "ASSIGNED_TO",
                looseDetails: [
                  { name: "role", type: "string" }
                ],
                strictDetails: [
                  { name: "cardinality", type: "M->N" }
                ]
              },
              {
                source: "Project",
                target: "City",
                relationship: "RUNS_IN",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Person",
                target: "Project",
                relationship: "ASSIGNED_TO",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->N" }
                ]
              }
            ]
          }
        },
        {
          iteration: 2,
          ts: 1731336420000, // 11:07
          metrics: {
            nodes: { precision: 0.86, recall: 0.80, f1Score: 0.83 },
            edges: { precision: 0.76, recall: 0.71, f1Score: 0.73 }
          },
          summary: { nodeTypes: 5, edges: 6 },
          snapshot: {
            nodes: [
              {
                name: "Person",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "id", type: "string", optional: false },
                  { name: "name", type: "string", optional: true }
                ]
              },
              {
                name: "Company",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "id", type: "string", optional: false },
                  { name: "name", type: "string", optional: true }
                ]
              },
              {
                name: "City",
                looseDetails: [
                  { name: "label", type: "string" }
                ],
                strictDetails: [
                  { name: "label", type: "string", optional: true }
                ]
              },
              {
                name: "Project",
                looseDetails: [
                  { name: "title", type: "string" }
                ],
                strictDetails: [
                  { name: "title", type: "string", optional: true }
                ]
              },
              {
                name: "Skill",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "name", type: "string", optional: true }
                ]
              }
            ],
            edges: [
              {
                source: "Person",
                target: "Company",
                relationship: "WORKS_AT",
                looseDetails: [
                  { name: "since", type: "date" }
                ],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Company",
                target: "City",
                relationship: "LOCATED_IN",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Person",
                target: "Project",
                relationship: "ASSIGNED_TO",
                looseDetails: [
                  { name: "role", type: "string" }
                ],
                strictDetails: [
                  { name: "cardinality", type: "M->N" }
                ]
              },
              {
                source: "Project",
                target: "City",
                relationship: "RUNS_IN",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Person",
                target: "Skill",
                relationship: "HAS_SKILL",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->N" }
                ]
              },
              {
                source: "Skill",
                target: "Project",
                relationship: "USED_IN",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->N" }
                ]
              }
            ]
          }
        },
        {
          iteration: 3,
          ts: 1731336540000, // 11:09
          metrics: {
            nodes: { precision: 0.89, recall: 0.82, f1Score: 0.855 },
            edges: { precision: 0.78, recall: 0.74, f1Score: 0.76 }
          },
          summary: { nodeTypes: 5, edges: 6 },
          snapshot: {
            nodes: [
              {
                name: "Person",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "id", type: "string", optional: false },
                  { name: "name", type: "string", optional: true }
                ]
              },
              {
                name: "Company",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "id", type: "string", optional: false },
                  { name: "name", type: "string", optional: true }
                ]
              },
              {
                name: "City",
                looseDetails: [
                  { name: "label", type: "string" }
                ],
                strictDetails: [
                  { name: "label", type: "string", optional: true }
                ]
              },
              {
                name: "Project",
                looseDetails: [
                  { name: "title", type: "string" }
                ],
                strictDetails: [
                  { name: "title", type: "string", optional: true }
                ]
              },
              {
                name: "Skill",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "name", type: "string", optional: true }
                ]
              }
            ],
            edges: [
              {
                source: "Person",
                target: "Company",
                relationship: "WORKS_AT",
                looseDetails: [
                  { name: "since", type: "date" }
                ],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Company",
                target: "City",
                relationship: "LOCATED_IN",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Person",
                target: "Project",
                relationship: "ASSIGNED_TO",
                looseDetails: [
                  { name: "role", type: "string" }
                ],
                strictDetails: [
                  { name: "cardinality", type: "M->N" }
                ]
              },
              {
                source: "Project",
                target: "City",
                relationship: "RUNS_IN",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Person",
                target: "Skill",
                relationship: "HAS_SKILL",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->N" }
                ]
              },
              {
                source: "Skill",
                target: "Project",
                relationship: "USED_IN",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->N" }
                ]
              }
            ]
          }
        }
      ],

      // logs as JSON lines
      logs:
`[INFO] 11:00 start incremental POLE size=500000
{"iteration":1,"metrics":{"nodes":{"precision":0.80,"recall":0.76,"f1Score":0.78},"edges":{"precision":0.73,"recall":0.68,"f1Score":0.70}},"summary":{"nodeTypes":4,"edges":5},"ts":1731336300000}
[DEBUG] merged previous patterns, reheat
{"iteration":2,"metrics":{"nodes":{"precision":0.86,"recall":0.80,"f1Score":0.83},"edges":{"precision":0.76,"recall":0.71,"f1Score":0.73}},"summary":{"nodeTypes":5,"edges":6},"ts":1731336420000}
[INFO] checking thresholds T=10 b=6 jaccard>=0.70
{"iteration":3,"metrics":{"nodes":{"precision":0.89,"recall":0.82,"f1Score":0.855},"edges":{"precision":0.78,"recall":0.74,"f1Score":0.76}},"summary":{"nodeTypes":5,"edges":6},"ts":1731336540000}
[INFO] 11:09 finished incremental POLE`,

      snapshot: {
        nodes: [
          {
            name: "Person",
            looseDetails: [
              { name: "name", type: "string" }
            ],
            strictDetails: [
              { name: "id", type: "string", optional: false },
              { name: "name", type: "string", optional: true }
            ]
          },
          {
            name: "Company",
            looseDetails: [
              { name: "name", type: "string" }
            ],
            strictDetails: [
              { name: "id", type: "string", optional: false },
              { name: "name", type: "string", optional: true }
            ]
          },
          {
            name: "City",
            looseDetails: [
              { name: "label", type: "string" }
            ],
            strictDetails: [
              { name: "label", type: "string", optional: true }
            ]
          },
          {
            name: "Project",
            looseDetails: [
              { name: "title", type: "string" }
            ],
            strictDetails: [
              { name: "title", type: "string", optional: true }
            ]
          },
          {
            name: "Skill",
            looseDetails: [
              { name: "name", type: "string" }
            ],
            strictDetails: [
              { name: "name", type: "string", optional: true }
            ]
          }
        ],
        edges: [
          {
            source: "Person",
            target: "Company",
            relationship: "WORKS_AT",
            looseDetails: [
              { name: "since", type: "date" }
            ],
            strictDetails: [
              { name: "cardinality", type: "M->1" }
            ]
          },
          {
            source: "Company",
            target: "City",
            relationship: "LOCATED_IN",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" }
            ]
          },
          {
            source: "Person",
            target: "Project",
            relationship: "ASSIGNED_TO",
            looseDetails: [
              { name: "role", type: "string" }
            ],
            strictDetails: [
              { name: "cardinality", type: "M->N" }
            ]
          },
          {
            source: "Project",
            target: "City",
            relationship: "RUNS_IN",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" }
            ]
          },
          {
            source: "Person",
            target: "Skill",
            relationship: "HAS_SKILL",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->N" }
            ]
          },
          {
            source: "Skill",
            target: "Project",
            relationship: "USED_IN",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->N" }
            ]
          }
        ]
      },
      _dataset: "POLE"
    }
  ],

  FIB25: [
    {
      id: "fib25_001",
      ts: 1731343200000, // 2024-11-12T13:00:00Z
      params: {
        dataset: "FIB25",
        incremental: false,
        knownTypeLabelPercentage: 100,
        adaptive: true,
        lshHashTables: 15,
        lshHashBucketLength: 5,
        jaccardSimilarityThreshold: 0.8
      },
      summary: { nodeTypes: 6, edges: 10 },
      metrics: {
        nodes: { precision: 0.93, recall: 0.91, f1Score: 0.92 },
        edges: { precision: 0.86, recall: 0.83, f1Score: 0.845 }
      },
      snapshot: {
        nodes: [
          {
            name: "Account",
            looseDetails: [
              { name: "iban", type: "string" }
            ],
            strictDetails: [
              { name: "id", type: "string", optional: false },
              { name: "iban", type: "string", optional: true }
            ]
          },
          {
            name: "Customer",
            looseDetails: [
              { name: "name", type: "string" }
            ],
            strictDetails: [
              { name: "id", type: "string", optional: false },
              { name: "name", type: "string", optional: true }
            ]
          },
          {
            name: "Transaction",
            looseDetails: [
              { name: "amount", type: "double" }
            ],
            strictDetails: [
              { name: "tid", type: "string", optional: false },
              { name: "amount", type: "double", optional: true }
            ]
          },
          {
            name: "Branch",
            looseDetails: [
              { name: "city", type: "string" }
            ],
            strictDetails: [
              { name: "city", type: "string", optional: true }
            ]
          },
          {
            name: "Merchant",
            looseDetails: [
              { name: "name", type: "string" }
            ],
            strictDetails: [
              { name: "name", type: "string", optional: true }
            ]
          },
          {
            name: "Category",
            looseDetails: [
              { name: "label", type: "string" }
            ],
            strictDetails: [
              { name: "label", type: "string", optional: true }
            ]
          }
        ],
        edges: [
          {
            source: "Customer",
            target: "Account",
            relationship: "OWNS",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "1->N" } // ένας customer, πολλά accounts
            ]
          },
          {
            source: "Account",
            target: "Transaction",
            relationship: "HAS_TX",
            looseDetails: [
              { name: "ts", type: "date" }
            ],
            strictDetails: [
              { name: "cardinality", type: "1->N" } // ένα account, πολλές transactions
            ]
          },
          {
            source: "Transaction",
            target: "Merchant",
            relationship: "AT",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" } // πολλές transactions σε έναν merchant
            ]
          },
          {
            source: "Merchant",
            target: "Category",
            relationship: "IN_CATEGORY",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" } // πολλοί merchants σε μία category
            ]
          },
          {
            source: "Account",
            target: "Branch",
            relationship: "OPENED_AT",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" } // πολλά accounts σε ένα branch
            ]
          }
        ]
      },
      _dataset: "FIB25"
    },

    {
      id: "fib25_002",
      ts: 1731346800000, // 2024-11-12T14:00:00Z
      params: {
        dataset: "FIB25",
        incremental: true,
        incrementalValue: 1000000,
        knownTypeLabelPercentage: 50,
        adaptive: false,
        lshHashTables: 12,
        lshHashBucketLength: 7,
        jaccardSimilarityThreshold: 0.78
      },
      summary: { nodeTypes: 7, edges: 12 },
      metrics: {
        nodes: { precision: 0.9, recall: 0.86, f1Score: 0.88 },
        edges: { precision: 0.82, recall: 0.8, f1Score: 0.81 }
      },

      iterations: [
        {
          iteration: 1,
          ts: 1731347100000, // 14:05
          metrics: {
            nodes: { precision: 0.78, recall: 0.67, f1Score: 0.72 },
            edges: { precision: 0.72, recall: 0.64, f1Score: 0.68 }
          },
          summary: { nodeTypes: 5, edges: 7 },
          snapshot: {
            nodes: [
              {
                name: "Account",
                looseDetails: [
                  { name: "iban", type: "string" }
                ],
                strictDetails: [
                  { name: "iban", type: "string", optional: true }
                ]
              },
              {
                name: "Customer",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "name", type: "string", optional: true }
                ]
              },
              {
                name: "Transaction",
                looseDetails: [
                  { name: "amount", type: "double" }
                ],
                strictDetails: [
                  { name: "amount", type: "double", optional: true }
                ]
              }
            ],
            edges: [
              {
                source: "Customer",
                target: "Account",
                relationship: "OWNS",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "1->N" }
                ]
              },
              {
                source: "Account",
                target: "Transaction",
                relationship: "HAS_TX",
                looseDetails: [
                  { name: "ts", type: "date" }
                ],
                strictDetails: [
                  { name: "cardinality", type: "1->N" }
                ]
              }
            ]
          }
        },
        {
          iteration: 2,
          ts: 1731347400000, // 14:10
          metrics: {
            nodes: { precision: 0.84, recall: 0.74, f1Score: 0.79 },
            edges: { precision: 0.76, recall: 0.72, f1Score: 0.74 }
          },
          summary: { nodeTypes: 6, edges: 9 },
          snapshot: {
            nodes: [
              {
                name: "Account",
                looseDetails: [
                  { name: "iban", type: "string" }
                ],
                strictDetails: [
                  { name: "id", type: "string", optional: false },
                  { name: "iban", type: "string", optional: true }
                ]
              },
              {
                name: "Customer",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "name", type: "string", optional: true }
                ]
              },
              {
                name: "Transaction",
                looseDetails: [
                  { name: "amount", type: "double" }
                ],
                strictDetails: [
                  { name: "amount", type: "double", optional: true }
                ]
              },
              {
                name: "Branch",
                looseDetails: [
                  { name: "city", type: "string" }
                ],
                strictDetails: [
                  { name: "city", type: "string", optional: true }
                ]
              }
            ],
            edges: [
              {
                source: "Customer",
                target: "Account",
                relationship: "OWNS",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "1->N" }
                ]
              },
              {
                source: "Account",
                target: "Transaction",
                relationship: "HAS_TX",
                looseDetails: [
                  { name: "ts", type: "date" }
                ],
                strictDetails: [
                  { name: "cardinality", type: "1->N" }
                ]
              },
              {
                source: "Account",
                target: "Branch",
                relationship: "OPENED_AT",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              }
            ]
          }
        },
        {
          iteration: 3,
          ts: 1731347700000, // 14:15
          metrics: {
            nodes: { precision: 0.88, recall: 0.82, f1Score: 0.85 },
            edges: { precision: 0.8, recall: 0.78, f1Score: 0.79 }
          },
          summary: { nodeTypes: 7, edges: 11 },
          snapshot: {
            nodes: [
              {
                name: "Account",
                looseDetails: [
                  { name: "iban", type: "string" }
                ],
                strictDetails: [
                  { name: "id", type: "string", optional: false },
                  { name: "iban", type: "string", optional: true }
                ]
              },
              {
                name: "Customer",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "name", type: "string", optional: true }
                ]
              },
              {
                name: "Transaction",
                looseDetails: [
                  { name: "amount", type: "double" }
                ],
                strictDetails: [
                  { name: "amount", type: "double", optional: true }
                ]
              },
              {
                name: "Branch",
                looseDetails: [
                  { name: "city", type: "string" }
                ],
                strictDetails: [
                  { name: "city", type: "string", optional: true }
                ]
              },
              {
                name: "Merchant",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "name", type: "string", optional: true }
                ]
              }
            ],
            edges: [
              {
                source: "Customer",
                target: "Account",
                relationship: "OWNS",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "1->N" }
                ]
              },
              {
                source: "Account",
                target: "Transaction",
                relationship: "HAS_TX",
                looseDetails: [
                  { name: "ts", type: "date" }
                ],
                strictDetails: [
                  { name: "cardinality", type: "1->N" }
                ]
              },
              {
                source: "Transaction",
                target: "Merchant",
                relationship: "AT",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Account",
                target: "Branch",
                relationship: "OPENED_AT",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              }
            ]
          }
        },
        {
          iteration: 4,
          ts: 1731348000000, // 14:20
          metrics: {
            nodes: { precision: 0.9, recall: 0.86, f1Score: 0.88 },
            edges: { precision: 0.82, recall: 0.8, f1Score: 0.81 }
          },
          summary: { nodeTypes: 7, edges: 12 },
          snapshot: {
            nodes: [
              {
                name: "Account",
                looseDetails: [
                  { name: "iban", type: "string" }
                ],
                strictDetails: [
                  { name: "id", type: "string", optional: false },
                  { name: "iban", type: "string", optional: true }
                ]
              },
              {
                name: "Customer",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "name", type: "string", optional: true }
                ]
              },
              {
                name: "Transaction",
                looseDetails: [
                  { name: "amount", type: "double" }
                ],
                strictDetails: [
                  { name: "amount", type: "double", optional: true }
                ]
              },
              {
                name: "Branch",
                looseDetails: [
                  { name: "city", type: "string" }
                ],
                strictDetails: [
                  { name: "city", type: "string", optional: true }
                ]
              },
              {
                name: "Merchant",
                looseDetails: [
                  { name: "name", type: "string" }
                ],
                strictDetails: [
                  { name: "name", type: "string", optional: true }
                ]
              },
              {
                name: "Category",
                looseDetails: [
                  { name: "label", type: "string" }
                ],
                strictDetails: [
                  { name: "label", type: "string", optional: true }
                ]
              },
              {
                name: "Device",
                looseDetails: [
                  { name: "type", type: "string" }
                ],
                strictDetails: [
                  { name: "type", type: "string", optional: true }
                ]
              }
            ],
            edges: [
              {
                source: "Customer",
                target: "Account",
                relationship: "OWNS",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "1->N" }
                ]
              },
              {
                source: "Account",
                target: "Transaction",
                relationship: "HAS_TX",
                looseDetails: [
                  { name: "ts", type: "date" }
                ],
                strictDetails: [
                  { name: "cardinality", type: "1->N" }
                ]
              },
              {
                source: "Transaction",
                target: "Merchant",
                relationship: "AT",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Merchant",
                target: "Category",
                relationship: "IN_CATEGORY",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Account",
                target: "Branch",
                relationship: "OPENED_AT",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" }
                ]
              },
              {
                source: "Transaction",
                target: "Device",
                relationship: "MADE_WITH",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->1" } // πολλές TX με το ίδιο device
                ]
              },
              {
                source: "Customer",
                target: "Device",
                relationship: "USES",
                looseDetails: [],
                strictDetails: [
                  { name: "cardinality", type: "M->N" }
                ]
              }
            ]
          }
        }
      ],

      logs:
`[INFO] 14:00 start incremental FIB25
{"iteration":1,"metrics":{"nodes":{"precision":0.78,"recall":0.67,"f1Score":0.72},"edges":{"precision":0.72,"recall":0.64,"f1Score":0.68}},"summary":{"nodeTypes":5,"edges":7},"ts":1731347100000}
some non-json line...
{"iteration":2,"metrics":{"nodes":{"precision":0.84,"recall":0.74,"f1Score":0.79},"edges":{"precision":0.76,"recall":0.72,"f1Score":0.74}},"summary":{"nodeTypes":6,"edges":9},"ts":1731347400000}
[DEBUG] clustering step 2 done
{"iteration":3,"metrics":{"nodes":{"precision":0.88,"recall":0.82,"f1Score":0.85},"edges":{"precision":0.80,"recall":0.78,"f1Score":0.79}},"summary":{"nodeTypes":7,"edges":11},"ts":1731347700000}
{"iteration":4,"metrics":{"nodes":{"precision":0.90,"recall":0.86,"f1Score":0.88},"edges":{"precision":0.82,"recall":0.80,"f1Score":0.81}},"summary":{"nodeTypes":7,"edges":12},"ts":1731348000000}
[INFO] 14:20 finished incremental FIB25`,

      snapshot: {
        nodes: [
          {
            name: "Account",
            looseDetails: [
              { name: "iban", type: "string" }
            ],
            strictDetails: [
              { name: "id", type: "string", optional: false },
              { name: "iban", type: "string", optional: true }
            ]
          },
          {
            name: "Customer",
            looseDetails: [
              { name: "name", type: "string" }
            ],
            strictDetails: [
              { name: "name", type: "string", optional: true }
            ]
          },
          {
            name: "Transaction",
            looseDetails: [
              { name: "amount", type: "double" }
            ],
            strictDetails: [
              { name: "amount", type: "double", optional: true }
            ]
          },
          {
            name: "Branch",
            looseDetails: [
              { name: "city", type: "string" }
            ],
            strictDetails: [
              { name: "city", type: "string", optional: true }
            ]
          },
          {
            name: "Merchant",
            looseDetails: [
              { name: "name", type: "string" }
            ],
            strictDetails: [
              { name: "name", type: "string", optional: true }
            ]
          },
          {
            name: "Category",
            looseDetails: [
              { name: "label", type: "string" }
            ],
            strictDetails: [
              { name: "label", type: "string", optional: true }
            ]
          },
          {
            name: "Device",
            looseDetails: [
              { name: "type", type: "string" }
            ],
            strictDetails: [
              { name: "type", type: "string", optional: true }
            ]
          }
        ],
        edges: [
          {
            source: "Customer",
            target: "Account",
            relationship: "OWNS",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "1->N" }
            ]
          },
          {
            source: "Account",
            target: "Transaction",
            relationship: "HAS_TX",
            looseDetails: [
              { name: "ts", type: "date" }
            ],
            strictDetails: [
              { name: "cardinality", type: "1->N" }
            ]
          },
          {
            source: "Transaction",
            target: "Merchant",
            relationship: "AT",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" }
            ]
          },
          {
            source: "Merchant",
            target: "Category",
            relationship: "IN_CATEGORY",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" }
            ]
          },
          {
            source: "Account",
            target: "Branch",
            relationship: "OPENED_AT",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" }
            ]
          },
          {
            source: "Transaction",
            target: "Device",
            relationship: "MADE_WITH",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" }
            ]
          },
          {
            source: "Customer",
            target: "Device",
            relationship: "USES",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->N" }
            ]
          }
        ]
      },
      _dataset: "FIB25"
    }
  ],

  LDBC: [
    {
      id: "ldbc_001",
      ts: 1731350400000, // 2024-11-12T15:00:00Z
      params: {
        dataset: "LDBC",
        incremental: false,
        knownTypeLabelPercentage: 100,
        adaptive: true,
        lshHashTables: 18,
        lshHashBucketLength: 5,
        jaccardSimilarityThreshold: 0.82
      },
      summary: { nodeTypes: 6, edges: 9 },
      metrics: {
        nodes: { precision: 0.94, recall: 0.9, f1Score: 0.92 },
        edges: { precision: 0.87, recall: 0.84, f1Score: 0.855 }
      },
      snapshot: {
        nodes: [
          {
            name: "Person",
            looseDetails: [
              { name: "firstName", type: "string" }
            ],
            strictDetails: [
              { name: "pid", type: "string", optional: false },
              { name: "firstName", type: "string", optional: true }
            ]
          },
          {
            name: "Comment",
            looseDetails: [
              { name: "content", type: "string" }
            ],
            strictDetails: [
              { name: "content", type: "string", optional: true }
            ]
          },
          {
            name: "Post",
            looseDetails: [
              { name: "creationDate", type: "date" }
            ],
            strictDetails: [
              { name: "creationDate", type: "date", optional: true }
            ]
          },
          {
            name: "Forum",
            looseDetails: [
              { name: "title", type: "string" }
            ],
            strictDetails: [
              { name: "title", type: "string", optional: true }
            ]
          },
          {
            name: "Tag",
            looseDetails: [
              { name: "name", type: "string" }
            ],
            strictDetails: [
              { name: "name", type: "string", optional: true }
            ]
          },
          {
            name: "Place",
            looseDetails: [
              { name: "name", type: "string" }
            ],
            strictDetails: [
              { name: "name", type: "string", optional: true }
            ]
          }
        ],
        edges: [
          {
            source: "Person",
            target: "Post",
            relationship: "CREATED",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "1->N" } // ένας Person, πολλά Post
            ]
          },
          {
            source: "Post",
            target: "Comment",
            relationship: "HAS_COMMENT",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "1->N" } // ένα Post, πολλά Comment
            ]
          },
          {
            source: "Forum",
            target: "Post",
            relationship: "CONTAINS",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "1->N" } // ένα Forum, πολλά Post
            ]
          },
          {
            source: "Post",
            target: "Tag",
            relationship: "HAS_TAG",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->N" } // πολλά Post, πολλά Tag
            ]
          },
          {
            source: "Person",
            target: "Place",
            relationship: "IS_LOCATED_IN",
            looseDetails: [],
            strictDetails: [
              { name: "cardinality", type: "M->1" } // πολλοί Person σε ένα Place
            ]
          }
        ]
      },
      _dataset: "LDBC"
    }
     ],

  MB6: [
    {
      id: "mb6_001",
      ts: 1731337800000, // 2024-11-12T11:30:00Z
      params: {
        dataset: "MB6",
        incremental: false,
        knownTypeLabelPercentage: 100,
        adaptive: true,
        lshHashTables: 20,
        lshHashBucketLength: 4,
        jaccardSimilarityThreshold: 0.75
      },
      summary: { nodeTypes: 4, edges: 4 },
      metrics: {
        nodes: { precision: 0.98, recall: 0.97, f1Score: 0.975 },
        edges: { precision: 0.99, recall: 0.98, f1Score: 0.985 }
      },
      snapshot: {
        nodes: [
          {
            name: "Building",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "id", type: "string", optional: false }]
          },
          {
            name: "Meter",
            looseDetails: [{ name: "meterId", type: "string" }],
            strictDetails: [{ name: "meterId", type: "string", optional: false }]
          },
          {
            name: "Sensor",
            looseDetails: [{ name: "sensorType", type: "string" }],
            strictDetails: [{ name: "sensorType", type: "string", optional: true }]
          },
          {
            name: "Reading",
            looseDetails: [{ name: "value", type: "float" }],
            strictDetails: [{ name: "timestamp", type: "datetime", optional: false }]
          }
        ],
        edges: [
          {
            source: "Building",
            target: "Meter",
            relationship: "HAS_METER",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "1->N" }]
          },
          {
            source: "Meter",
            target: "Sensor",
            relationship: "HAS_SENSOR",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "1->N" }]
          },
          {
            source: "Sensor",
            target: "Reading",
            relationship: "REPORTED",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "1->N" }]
          },
          {
            source: "Reading",
            target: "Building",
            relationship: "RECORDED_AT",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "N->1" }]
          }
        ]
      },
      logs: [
        "[11:30:00] Start PG-HIVE for MB6",
        "[11:30:04] Loaded MB6 nodes and edges",
        "[11:30:26] F1 nodes=0.975 edges=0.985",
        "[11:30:27] Done"
      ],
      _dataset: "MB6"
    }
  ],

  HETIO: [
    {
      id: "hetio_001",
      ts: 1731340800000, // 2024-11-12T12:20:00Z
      params: {
        dataset: "HETIO",
        incremental: false,
        knownTypeLabelPercentage: 100,
        adaptive: true,
        lshHashTables: 20,
        lshHashBucketLength: 4,
        jaccardSimilarityThreshold: 0.75
      },
      summary: { nodeTypes: 4, edges: 4 },
      metrics: {
        nodes: { precision: 0.99, recall: 0.97, f1Score: 0.98 },
        edges: { precision: 0.87, recall: 0.83, f1Score: 0.85 }
      },
      snapshot: {
        nodes: [
          {
            name: "Gene",
            looseDetails: [{ name: "symbol", type: "string" }],
            strictDetails: [{ name: "symbol", type: "string", optional: false }]
          },
          {
            name: "Disease",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "name", type: "string", optional: false }]
          },
          {
            name: "Compound",
            looseDetails: [{ name: "drugbankId", type: "string" }],
            strictDetails: [{ name: "drugbankId", type: "string", optional: false }]
          },
          {
            name: "Anatomy",
            looseDetails: [{ name: "label", type: "string" }],
            strictDetails: [{ name: "label", type: "string", optional: true }]
          }
        ],
        edges: [
          {
            source: "Gene",
            target: "Disease",
            relationship: "ASSOCIATES",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          },
          {
            source: "Compound",
            target: "Gene",
            relationship: "BINDS",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          },
          {
            source: "Compound",
            target: "Disease",
            relationship: "TREATS",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          },
          {
            source: "Disease",
            target: "Anatomy",
            relationship: "LOCALIZES",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          }
        ]
      },
      logs: [
        "[12:20:00] Start PG-HIVE for HETIO",
        "[12:20:03] Applied adaptive type grouping",
        "[12:20:19] F1 nodes=0.98 edges=0.85",
        "[12:20:20] Done"
      ],
      _dataset: "HETIO"
    }
  ],

  ICIJ: [
    {
      id: "icij_001",
      ts: 1731344400000, // 2024-11-12T13:20:00Z
      params: {
        dataset: "ICIJ",
        incremental: false,
        knownTypeLabelPercentage: 100,
        adaptive: true,
        lshHashTables: 20,
        lshHashBucketLength: 4,
        jaccardSimilarityThreshold: 0.75
      },
      summary: { nodeTypes: 4, edges: 4 },
      metrics: {
        nodes: { precision: 0.92, recall: 0.89, f1Score: 0.905 },
        edges: { precision: 0.97, recall: 0.94, f1Score: 0.955 }
      },
      snapshot: {
        nodes: [
          {
            name: "Officer",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "name", type: "string", optional: false }]
          },
          {
            name: "Entity",
            looseDetails: [{ name: "jurisdiction", type: "string" }],
            strictDetails: [{ name: "jurisdiction", type: "string", optional: true }]
          },
          {
            name: "Intermediary",
            looseDetails: [{ name: "sourceId", type: "string" }],
            strictDetails: [{ name: "sourceId", type: "string", optional: false }]
          },
          {
            name: "Address",
            looseDetails: [{ name: "country", type: "string" }],
            strictDetails: [{ name: "country", type: "string", optional: true }]
          }
        ],
        edges: [
          {
            source: "Officer",
            target: "Entity",
            relationship: "OFFICER_OF",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          },
          {
            source: "Intermediary",
            target: "Entity",
            relationship: "INTERMEDIARY_OF",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          },
          {
            source: "Entity",
            target: "Address",
            relationship: "REGISTERED_ADDRESS",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->1" }]
          },
          {
            source: "Officer",
            target: "Entity",
            relationship: "SHAREHOLDER_OF",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          }
        ]
      },
      logs: [
        "[13:20:00] Start PG-HIVE for ICIJ",
        "[13:20:07] Built candidate relationships",
        "[13:20:38] F1 nodes=0.905 edges=0.955",
        "[13:20:39] Done"
      ],
      _dataset: "ICIJ"
    }
  ],

  CORD19: [
    {
      id: "cord19_001",
      ts: 1731348000000, // 2024-11-12T14:20:00Z
      params: {
        dataset: "CORD19",
        incremental: false,
        knownTypeLabelPercentage: 100,
        adaptive: true,
        lshHashTables: 20,
        lshHashBucketLength: 4,
        jaccardSimilarityThreshold: 0.75
      },
      summary: { nodeTypes: 4, edges: 4 },
      metrics: {
        nodes: { precision: 0.97, recall: 0.96, f1Score: 0.965 },
        edges: { precision: 0.84, recall: 0.79, f1Score: 0.815 }
      },
      snapshot: {
        nodes: [
          {
            name: "Paper",
            looseDetails: [{ name: "title", type: "string" }],
            strictDetails: [{ name: "paperId", type: "string", optional: false }]
          },
          {
            name: "Author",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "name", type: "string", optional: false }]
          },
          {
            name: "Affiliation",
            looseDetails: [{ name: "institution", type: "string" }],
            strictDetails: [{ name: "institution", type: "string", optional: true }]
          },
          {
            name: "Concept",
            looseDetails: [{ name: "term", type: "string" }],
            strictDetails: [{ name: "term", type: "string", optional: true }]
          }
        ],
        edges: [
          {
            source: "Paper",
            target: "Author",
            relationship: "AUTHORED_BY",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          },
          {
            source: "Author",
            target: "Affiliation",
            relationship: "AFFILIATED_WITH",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          },
          {
            source: "Paper",
            target: "Paper",
            relationship: "CITES",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          },
          {
            source: "Paper",
            target: "Concept",
            relationship: "HAS_CONCEPT",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          }
        ]
      },
      logs: [
        "[14:20:00] Start PG-HIVE for CORD19",
        "[14:20:11] Processed high-degree publication nodes",
        "[14:20:51] F1 nodes=0.965 edges=0.815",
        "[14:20:52] Done"
      ],
      _dataset: "CORD19"
    }
  ],

  IYP: [
    {
      id: "iyp_001",
      ts: 1731351600000, // 2024-11-12T15:20:00Z
      params: {
        dataset: "IYP",
        incremental: false,
        knownTypeLabelPercentage: 100,
        adaptive: true,
        lshHashTables: 20,
        lshHashBucketLength: 4,
        jaccardSimilarityThreshold: 0.75
      },
      summary: { nodeTypes: 4, edges: 4 },
      metrics: {
        nodes: { precision: 0.80, recall: 0.75, f1Score: 0.775 },
        edges: { precision: 0.87, recall: 0.82, f1Score: 0.845 }
      },
      snapshot: {
        nodes: [
          {
            name: "AS",
            looseDetails: [{ name: "asn", type: "int" }],
            strictDetails: [{ name: "asn", type: "int", optional: false }]
          },
          {
            name: "Prefix",
            looseDetails: [{ name: "cidr", type: "string" }],
            strictDetails: [{ name: "cidr", type: "string", optional: false }]
          },
          {
            name: "IXP",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "name", type: "string", optional: true }]
          },
          {
            name: "Country",
            looseDetails: [{ name: "code", type: "string" }],
            strictDetails: [{ name: "code", type: "string", optional: true }]
          }
        ],
        edges: [
          {
            source: "AS",
            target: "AS",
            relationship: "PEERS_WITH",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          },
          {
            source: "Prefix",
            target: "AS",
            relationship: "ORIGINATES",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->1" }]
          },
          {
            source: "AS",
            target: "IXP",
            relationship: "MEMBER_OF",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->N" }]
          },
          {
            source: "AS",
            target: "Country",
            relationship: "LOCATED_IN",
            looseDetails: [],
            strictDetails: [{ name: "cardinality", type: "M->1" }]
          }
        ]
      },
      logs: [
        "[15:20:00] Start PG-HIVE for IYP",
        "[15:20:06] Loaded autonomous system topology",
        "[15:20:33] F1 nodes=0.775 edges=0.845",
        "[15:20:34] Done"
      ],
      _dataset: "IYP"
    }
  ]
}


export const PG_BASELINE_RUNS = {
  // POLE: {
  //   gmm: {
  //     id: "pole_gmm_baseline_001",
  //     kind: "baseline",
  //     baseline: "GMM",
  //     algorithm: "GMM",
  //     ts: 1731330000000, // 2024-11-12T09:20:00Z
  //     params: {
  //       dataset: "POLE",
  //       algorithm: "GMM"
  //     },
  //     summary: { nodeTypes: 4, edges: 4 },
  //     metrics: {
  //       // χειρότερα από PG-HIVE (nodes f1 ~0.895, edges ~0.825)
  //       nodes: { precision: 0.86, recall: 0.80, f1Score: 0.83 },
  //       edges: { precision: 0.79, recall: 0.75, f1Score: 0.77 }
  //     },
  //     snapshot: {
  //       nodes: [
  //         {
  //           name: "Person",
  //           looseDetails: [{ name: "name", type: "string" }],
  //           strictDetails: [{ name: "name", type: "string" }]
  //         },
  //         {
  //           name: "Company",
  //           looseDetails: [{ name: "name", type: "string" }],
  //           strictDetails: [{ name: "name", type: "string" }]
  //         },
  //         {
  //           name: "City",
  //           looseDetails: [{ name: "label", type: "string" }],
  //           strictDetails: [{ name: "label", type: "string" }]
  //         },
  //         {
  //           name: "Project",
  //           looseDetails: [{ name: "title", type: "string" }],
  //           strictDetails: [{ name: "title", type: "string" }]
  //         }
  //       ],
  //       edges: [
  //         {
  //           source: "Person",
  //           target: "Company",
  //           relationship: "WORKS_AT",
  //           looseDetails: [],
  //           strictDetails: []
  //         },
  //         {
  //           source: "Company",
  //           target: "City",
  //           relationship: "LOCATED_IN",
  //           looseDetails: [],
  //           strictDetails: []
  //         },
  //         {
  //           source: "Person",
  //           target: "Project",
  //           relationship: "ASSIGNED_TO",
  //           looseDetails: [],
  //           strictDetails: []
  //         },
  //         {
  //           source: "Project",
  //           target: "City",
  //           relationship: "RUNS_IN",
  //           looseDetails: [],
  //           strictDetails: []
  //         }
  //       ]
  //     },
  //     logs: [
  //       "[09:20:00] Start GMM baseline on POLE",
  //       "[09:20:04] Initialized 8 Gaussian components",
  //       "[09:20:30] EM converged in 11 iterations",
  //       "[09:20:35] F1 nodes=0.83 edges=0.77",
  //       "[09:20:36] Done"
  //     ],
  //     _dataset: "POLE"
  //   },

  //   shemI: {
  //     id: "pole_shemI_baseline_001",
  //     kind: "baseline",
  //     baseline: "ShemI",
  //     algorithm: "ShemI",
  //     ts: 1731330600000, // 2024-11-12T09:30:00Z
  //     params: {
  //       dataset: "POLE",
  //       algorithm: "ShemI"
  //     },
  //     summary: { nodeTypes: 3, edges: 3 },
  //     metrics: {
  //       // λίγο χειρότερα από GMM baseline
  //       nodes: { precision: 0.82, recall: 0.76, f1Score: 0.79 },
  //       edges: { precision: 0.75, recall: 0.70, f1Score: 0.725 }
  //     },
  //     snapshot: {
  //       nodes: [
  //         {
  //           name: "Person",
  //           looseDetails: [{ name: "name", type: "string" }],
  //           strictDetails: [{ name: "name", type: "string" }]
  //         },
  //         {
  //           name: "Company",
  //           looseDetails: [{ name: "name", type: "string" }],
  //           strictDetails: [{ name: "name", type: "string" }]
  //         },
  //         {
  //           name: "City",
  //           looseDetails: [{ name: "label", type: "string" }],
  //           strictDetails: [{ name: "label", type: "string" }]
  //         }
  //       ],
  //       edges: [
  //         {
  //           source: "Person",
  //           target: "Company",
  //           relationship: "WORKS_AT",
  //           looseDetails: [],
  //           strictDetails: []
  //         },
  //         {
  //           source: "Company",
  //           target: "City",
  //           relationship: "LOCATED_IN",
  //           looseDetails: [],
  //           strictDetails: []
  //         },
  //         {
  //           source: "Person",
  //           target: "City",
  //           relationship: "LIVES_IN",
  //           looseDetails: [],
  //           strictDetails: []
  //         }
  //       ]
  //     },
  //     logs: [
  //       "[09:30:00] Start ShemI baseline on POLE",
  //       "[09:30:03] Loaded initial schema hints",
  //       "[09:30:40] Applied heuristic merging",
  //       "[09:30:55] F1 nodes=0.79 edges=0.725",
  //       "[09:30:56] Done"
  //     ],
  //     _dataset: "POLE"
  //   }
  // },

  FIB25: {
    gmm: {
      id: "fib25_gmm_baseline_001",
      kind: "baseline",
      baseline: "GMM",
      algorithm: "GMM",
      ts: 1731342600000, // 2024-11-12T12:50:00Z
      params: {
        dataset: "FIB25",
        algorithm: "GMM"
      },
      summary: { nodeTypes: 6, edges: 9 },
      metrics: {
        // PG-HIVE: nodes f1=0.92, edges=0.845
        nodes: { precision: 0.89, recall: 0.86, f1Score: 0.875 },
        edges: { precision: 0.81, recall: 0.79, f1Score: 0.80 }
      },
      snapshot: {
        nodes: [
          {
            name: "Account",
            looseDetails: [{ name: "iban", type: "string" }],
            strictDetails: [{ name: "iban", type: "string" }]
          },
          {
            name: "Customer",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "name", type: "string" }]
          },
          {
            name: "Transaction",
            looseDetails: [{ name: "amount", type: "double" }],
            strictDetails: [{ name: "amount", type: "double" }]
          },
          {
            name: "Branch",
            looseDetails: [{ name: "city", type: "string" }],
            strictDetails: [{ name: "city", type: "string" }]
          },
          {
            name: "Merchant",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "name", type: "string" }]
          },
          {
            name: "Category",
            looseDetails: [{ name: "label", type: "string" }],
            strictDetails: [{ name: "label", type: "string" }]
          }
        ],
        edges: [
          {
            source: "Customer",
            target: "Account",
            relationship: "OWNS",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Account",
            target: "Transaction",
            relationship: "HAS_TX",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Transaction",
            target: "Merchant",
            relationship: "AT",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Merchant",
            target: "Category",
            relationship: "IN_CATEGORY",
            looseDetails: [],
            strictDetails: []
          }
        ]
      },
      logs: [
        "[12:50:00] Start GMM baseline on FIB25",
        "[12:50:05] Initialized 10 components",
        "[12:50:45] EM converged in 9 iterations",
        "[12:50:50] F1 nodes=0.875 edges=0.80",
        "[12:50:52] Done"
      ],
      _dataset: "FIB25"
    },

    shemI: {
      id: "fib25_shemI_baseline_001",
      kind: "baseline",
      baseline: "ShemI",
      algorithm: "ShemI",
      ts: 1731342900000, // 2024-11-12T12:55:00Z
      params: {
        dataset: "FIB25",
        algorithm: "ShemI"
      },
      summary: { nodeTypes: 5, edges: 8 },
      metrics: {
        nodes: { precision: 0.86, recall: 0.82, f1Score: 0.84 },
        edges: { precision: 0.79, recall: 0.76, f1Score: 0.775 }
      },
      snapshot: {
        nodes: [
          {
            name: "Account",
            looseDetails: [{ name: "iban", type: "string" }],
            strictDetails: [{ name: "iban", type: "string" }]
          },
          {
            name: "Customer",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "name", type: "string" }]
          },
          {
            name: "Transaction",
            looseDetails: [{ name: "amount", type: "double" }],
            strictDetails: [{ name: "amount", type: "double" }]
          },
          {
            name: "Branch",
            looseDetails: [{ name: "city", type: "string" }],
            strictDetails: [{ name: "city", type: "string" }]
          },
          {
            name: "Merchant",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "name", type: "string" }]
          }
        ],
        edges: [
          {
            source: "Customer",
            target: "Account",
            relationship: "OWNS",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Account",
            target: "Transaction",
            relationship: "HAS_TX",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Transaction",
            target: "Merchant",
            relationship: "AT",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Account",
            target: "Branch",
            relationship: "OPENED_AT",
            looseDetails: [],
            strictDetails: []
          }
        ]
      },
      logs: [
        "[12:55:00] Start ShemI baseline on FIB25",
        "[12:55:03] Loaded account-based schema hints",
        "[12:55:35] Applied iterative merging (3 passes)",
        "[12:55:40] F1 nodes=0.84 edges=0.775",
        "[12:55:42] Done"
      ],
      _dataset: "FIB25"
    }
  },

  LDBC: {
    gmm: {
      id: "ldbc_gmm_baseline_001",
      kind: "baseline",
      baseline: "GMM",
      algorithm: "GMM",
      ts: 1731349800000, // 2024-11-12T14:50:00Z
      params: {
        dataset: "LDBC",
        algorithm: "GMM"
      },
      summary: { nodeTypes: 6, edges: 8 },
      metrics: {
        // PG-HIVE: nodes f1=0.92, edges=0.855
        nodes: { precision: 0.90, recall: 0.87, f1Score: 0.885 },
        edges: { precision: 0.83, recall: 0.80, f1Score: 0.815 }
      },
      snapshot: {
        nodes: [
          {
            name: "Person",
            looseDetails: [{ name: "firstName", type: "string" }],
            strictDetails: [{ name: "firstName", type: "string" }]
          },
          {
            name: "Comment",
            looseDetails: [{ name: "content", type: "string" }],
            strictDetails: [{ name: "content", type: "string" }]
          },
          {
            name: "Post",
            looseDetails: [{ name: "creationDate", type: "date" }],
            strictDetails: [{ name: "creationDate", type: "date" }]
          },
          {
            name: "Forum",
            looseDetails: [{ name: "title", type: "string" }],
            strictDetails: [{ name: "title", type: "string" }]
          },
          {
            name: "Tag",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "name", type: "string" }]
          },
          {
            name: "Place",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "name", type: "string" }]
          }
        ],
        edges: [
          {
            source: "Person",
            target: "Post",
            relationship: "CREATED",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Post",
            target: "Comment",
            relationship: "HAS_COMMENT",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Forum",
            target: "Post",
            relationship: "CONTAINS",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Post",
            target: "Tag",
            relationship: "HAS_TAG",
            looseDetails: [],
            strictDetails: []
          }
        ]
      },
      logs: [
        "[14:50:00] Start GMM baseline on LDBC",
        "[14:50:04] Initialized person/post/comment embeddings",
        "[14:50:40] EM converged in 10 iterations",
        "[14:50:45] F1 nodes=0.885 edges=0.815",
        "[14:50:46] Done"
      ],
      _dataset: "LDBC"
    },

    shemI: {
      id: "ldbc_shemI_baseline_001",
      kind: "baseline",
      baseline: "ShemI",
      algorithm: "ShemI",
      ts: 1731350100000, // 2024-11-12T14:55:00Z
      params: {
        dataset: "LDBC",
        algorithm: "ShemI"
      },
      summary: { nodeTypes: 5, edges: 7 },
      metrics: {
        nodes: { precision: 0.88, recall: 0.84, f1Score: 0.86 },
        edges: { precision: 0.81, recall: 0.78, f1Score: 0.795 }
      },
      snapshot: {
        nodes: [
          {
            name: "Person",
            looseDetails: [{ name: "firstName", type: "string" }],
            strictDetails: [{ name: "firstName", type: "string" }]
          },
          {
            name: "Comment",
            looseDetails: [{ name: "content", type: "string" }],
            strictDetails: [{ name: "content", type: "string" }]
          },
          {
            name: "Post",
            looseDetails: [{ name: "creationDate", type: "date" }],
            strictDetails: [{ name: "creationDate", type: "date" }]
          },
          {
            name: "Forum",
            looseDetails: [{ name: "title", type: "string" }],
            strictDetails: [{ name: "title", type: "string" }]
          },
          {
            name: "Place",
            looseDetails: [{ name: "name", type: "string" }],
            strictDetails: [{ name: "name", type: "string" }]
          }
        ],
        edges: [
          {
            source: "Person",
            target: "Post",
            relationship: "CREATED",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Post",
            target: "Comment",
            relationship: "HAS_COMMENT",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Forum",
            target: "Post",
            relationship: "CONTAINS",
            looseDetails: [],
            strictDetails: []
          },
          {
            source: "Person",
            target: "Place",
            relationship: "IS_LOCATED_IN",
            looseDetails: [],
            strictDetails: []
          }
        ]
      },
      logs: [
        "[14:55:00] Start ShemI baseline on LDBC",
        "[14:55:02] Loaded LDBC schema hints",
        "[14:55:30] Heuristic merging on forum/post/comment",
        "[14:55:40] F1 nodes=0.86 edges=0.795",
        "[14:55:42] Done"
      ],
      _dataset: "LDBC"
    }
  }
}

// Evaluation data for different datasets
// Based on PG-HIVE results (average of ELSH and MinHash) at 100% label availability, 0% noise
export const PG_EVALUATION_RUNS = {
  POLE: {
    detailed: {
      id: "pole_detailed_eval_001",
      kind: "evaluation",
      evaluationType: "detailed",
      ts: Date.now(),
      dataset: "POLE",
      results: {
        accuracy: 0.96,      // Average of nodes & edges
        coverage: 0.94,
        completeness: 0.95,
        consistency: 0.96,
        nodeTypeAccuracy: 0.96,  // (0.95 + 0.97) / 2
        edgeTypeAccuracy: 0.975, // (0.97 + 0.98) / 2
        propertyAccuracy: 0.94,
        nodeF1Score: 0.955,
        edgeF1Score: 0.965,
        executionTime: 2.34  // seconds
      },
      breakdown: {
        byNodeType: {
          "Node Type 1": { accuracy: 0.96, count: 15380 },
          "Node Type 2": { accuracy: 0.95, count: 15380 },
          "Node Type 3": { accuracy: 0.97, count: 15381 },
          "Node Type 4": { accuracy: 0.96, count: 15380 }
        },
        byEdgeType: {
          "Edge Type 1": { accuracy: 0.98, count: 26460 },
          "Edge Type 2": { accuracy: 0.97, count: 26460 },
          "Edge Type 3": { accuracy: 0.98, count: 26460 },
          "Edge Type 4": { accuracy: 0.97, count: 26460 }
        }
      },
      charts: {
        "100": {
          nodes: {
            SchemaI: [0.98, 0.88, 0.78, 0.72, 0.78],
            GMM: [0.88, 0.62, 0.52, 0.58, 0.55],
            "PG-HIVE-ELSH": [0.98, 0.92, 0.88, 0.85, 0.82],
            "PG-HIVE-MinHash": [0.98, 0.92, 0.88, 0.85, 0.78]
          },
          edges: {
            SchemaI: [0.92, 0.88, 0.88, 0.85, 0.85],
            GMM: [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.98, 0.98]
          }
        },
        "50": {
          nodes: {
            SchemaI: [0.98, 0.95, 0.88, 0.85, 0.88],
            GMM: [0.98, 0.92, 0.88, 0.88, 0.95],
            "PG-HIVE-ELSH": [0.98, 0.95, 0.85, 0.88, 0.88],
            "PG-HIVE-MinHash": [0.98, 0.95, 0.92, 0.88, 0.98]
          },
          edges: {
            SchemaI: [0.92, 0.88, 0.88, 0.85, 0.85],
            GMM: [0.92, 0.88, 0.85, 0.85, 0.88],
            "PG-HIVE-ELSH": [0.92, 0.88, 0.80, 0.85, 0.88],
            "PG-HIVE-MinHash": [0.92, 0.88, 0.88, 0.88, 0.88]
          }
        },
        "0": {
          nodes: {
            SchemaI: [1.0, 0.98, 0.95, 0.92, 0.95],
            GMM: [1.0, 0.98, 0.95, 0.92, 0.95],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.95, 0.92, 0.95],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.95, 0.92, 0.95]
          },
          edges: {
            SchemaI: [1.0, 0.98, 0.95, 0.95, 0.98],
            GMM: [1.0, 0.98, 0.95, 0.95, 0.98],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.95, 0.95, 0.98],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.95, 0.95, 0.98]
          }
        }
      }
    }
  },
  MB6: {
    detailed: {
      id: "mb6_detailed_eval_001",
      kind: "evaluation",
      evaluationType: "detailed",
      ts: Date.now(),
      dataset: "MB6",
      results: {
        accuracy: 0.985,
        coverage: 0.97,
        completeness: 0.98,
        consistency: 0.99,
        nodeTypeAccuracy: 0.98,   // (0.97 + 0.99) / 2
        edgeTypeAccuracy: 0.99,
        propertyAccuracy: 0.98,
        nodeF1Score: 0.975,
        edgeF1Score: 0.985,
        executionTime: 8.12  // seconds
      },
      breakdown: {
        byNodeType: {
          "Node Type 1": { accuracy: 0.98, count: 121567 },
          "Node Type 2": { accuracy: 0.97, count: 121567 },
          "Node Type 3": { accuracy: 0.99, count: 121566 },
          "Node Type 4": { accuracy: 0.98, count: 121567 }
        },
        byEdgeType: {
          "Edge Type 1": { accuracy: 0.99, count: 240393 },
          "Edge Type 2": { accuracy: 0.99, count: 240393 },
          "Edge Type 3": { accuracy: 0.99, count: 240392 },
          "Edge Type 4": { accuracy: 0.99, count: 240393 }
        }
      },
      charts: {
        "100": {
          nodes: {
            SchemaI: [0.78, 0.78, 0.75, 0.72, 0.75],
            GMM: [0.98, 0.95, 0.92, 0.90, 0.92],
            "PG-HIVE-ELSH": [0.98, 0.95, 0.95, 0.95, 0.95],
            "PG-HIVE-MinHash": [0.98, 0.95, 0.95, 0.95, 0.95]
          },
          edges: {
            SchemaI: [0.82, 0.78, 0.75, 0.75, 0.78],
            GMM: [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.98, 0.98]
          }
        },
        "50": {
          nodes: {
            SchemaI: [0.98, 0.95, 0.95, 0.92, 0.92],
            GMM: [0.98, 0.95, 0.95, 0.95, 0.95],
            "PG-HIVE-ELSH": [0.98, 0.95, 0.92, 0.88, 0.85],
            "PG-HIVE-MinHash": [0.98, 0.95, 0.95, 0.95, 0.95]
          },
          edges: {
            SchemaI: [0.98, 0.95, 0.95, 0.95, 0.92],
            GMM: [0.98, 0.95, 0.95, 0.95, 0.92],
            "PG-HIVE-ELSH": [0.98, 0.95, 0.95, 0.95, 0.92],
            "PG-HIVE-MinHash": [0.98, 0.95, 0.95, 0.95, 0.92]
          }
        },
        "0": {
          nodes: {
            SchemaI: [0.98, 0.98, 0.98, 0.98, 0.95],
            GMM: [0.98, 0.98, 0.98, 0.98, 0.95],
            "PG-HIVE-ELSH": [0.98, 0.98, 0.98, 0.98, 0.95],
            "PG-HIVE-MinHash": [0.98, 0.98, 0.98, 0.98, 0.95]
          },
          edges: {
            SchemaI: [0.88, 0.82, 0.78, 0.82, 0.85],
            GMM: [0.88, 0.82, 0.78, 0.82, 0.85],
            "PG-HIVE-ELSH": [0.88, 0.82, 0.78, 0.82, 0.85],
            "PG-HIVE-MinHash": [0.88, 0.82, 0.78, 0.82, 0.85]
          }
        }
      }
    }
  },
  HETIO: {
    detailed: {
      id: "hetio_detailed_eval_001",
      kind: "evaluation",
      evaluationType: "detailed",
      ts: Date.now(),
      dataset: "HETIO",
      results: {
        accuracy: 0.94,
        coverage: 0.92,
        completeness: 0.93,
        consistency: 0.95,
        nodeTypeAccuracy: 0.985,  // (0.98 + 0.99) / 2
        edgeTypeAccuracy: 0.86,   // (0.82 + 0.90) / 2
        propertyAccuracy: 0.92,
        nodeF1Score: 0.98,
        edgeF1Score: 0.85,
        executionTime: 18.45  // seconds
      },
      breakdown: {
        byNodeType: {
          "Gene": { accuracy: 0.99, count: 11758 },
          "Disease": { accuracy: 0.98, count: 11758 },
          "Compound": { accuracy: 0.985, count: 11758 },
          "Anatomy": { accuracy: 0.99, count: 11757 }
        },
        byEdgeType: {
          "ASSOCIATES": { accuracy: 0.86, count: 562549 },
          "TREATS": { accuracy: 0.85, count: 562549 },
          "BINDS": { accuracy: 0.87, count: 562549 },
          "REGULATES": { accuracy: 0.86, count: 562550 }
        }
      },
      charts: {
        "100": {
          nodes: {
            SchemaI: [0.88, 0.78, 0.70, 0.68, 0.58],
            GMM: [0.95, 0.68, 0.48, 0.55, 0.55],
            "PG-HIVE-ELSH": [1.0, 1.0, 1.0, 1.0, 1.0],
            "PG-HIVE-MinHash": [1.0, 1.0, 0.98, 0.98, 0.98]
          },
          edges: {
            SchemaI: [0.78, 0.70, 0.65, 0.62, 0.62],
            GMM: [0.95, 0.88, 0.88, 0.88, 0.88],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-MinHash": [0.92, 0.88, 0.88, 0.88, 0.88]
          }
        },
        "50": {
          nodes: {
            SchemaI: [1.0, 0.98, 0.95, 0.92, 0.95],
            GMM: [1.0, 0.95, 0.92, 0.95, 0.98],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.95, 0.92, 1.0],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.98, 1.0]
          },
          edges: {
            SchemaI: [0.88, 0.85, 0.85, 0.85, 0.88],
            GMM: [0.88, 0.82, 0.80, 0.78, 0.88],
            "PG-HIVE-ELSH": [0.88, 0.82, 0.80, 0.78, 0.88],
            "PG-HIVE-MinHash": [0.92, 0.88, 0.88, 0.88, 0.92]
          }
        },
        "0": {
          nodes: {
            SchemaI: [1.0, 0.98, 0.95, 0.95, 0.98],
            GMM: [1.0, 0.98, 0.95, 0.95, 0.98],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.95, 0.95, 0.98],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.98, 0.98]
          },
          edges: {
            SchemaI: [0.92, 0.88, 0.88, 0.88, 0.88],
            GMM: [0.92, 0.88, 0.88, 0.88, 0.88],
            "PG-HIVE-ELSH": [0.92, 0.85, 0.85, 0.85, 0.85],
            "PG-HIVE-MinHash": [0.92, 0.88, 0.88, 0.88, 0.88]
          }
        }
      }
    }
  },
  FIB25: {
    detailed: {
      id: "fib25_detailed_eval_001",
      kind: "evaluation",
      evaluationType: "detailed",
      ts: Date.now(),
      dataset: "FIB25",
      results: {
        accuracy: 0.91,
        coverage: 0.89,
        completeness: 0.90,
        consistency: 0.92,
        nodeTypeAccuracy: 0.985,  // (0.98 + 0.99) / 2
        edgeTypeAccuracy: 0.825,  // ~0.80-0.85 average
        propertyAccuracy: 0.88,
        nodeF1Score: 0.98,
        edgeF1Score: 0.815,
        executionTime: 32.67  // seconds
      },
      breakdown: {
        byNodeType: {
          "Entity 1": { accuracy: 0.99, count: 200618 },
          "Entity 2": { accuracy: 0.98, count: 200618 },
          "Entity 3": { accuracy: 0.99, count: 200618 },
          "Entity 4": { accuracy: 0.98, count: 200619 }
        },
        byEdgeType: {
          "RELATES_TO": { accuracy: 0.83, count: 406357 },
          "CONNECTS": { accuracy: 0.82, count: 406357 },
          "LINKS": { accuracy: 0.83, count: 406357 },
          "ASSOCIATES": { accuracy: 0.82, count: 406357 }
        }
      },
      charts: {
        "100": {
          nodes: {
            SchemaI: [0.82, 0.75, 0.72, 0.70, 0.68],
            GMM: [1.0, 0.82, 0.62, 0.52, 0.62],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.98, 0.95, 0.98],
            "PG-HIVE-MinHash": [0.98, 0.95, 0.98, 0.95, 0.98]
          },
          edges: {
            SchemaI: [0.85, 0.78, 0.80, 0.78, 0.78],
            GMM: [1.0, 1.0, 1.0, 1.0, 1.0],
            "PG-HIVE-ELSH": [1.0, 1.0, 1.0, 1.0, 1.0],
            "PG-HIVE-MinHash": [1.0, 1.0, 1.0, 1.0, 1.0]
          }
        },
        "50": {
          nodes: {
            SchemaI: [1.0, 0.98, 0.98, 0.95, 0.92],
            GMM: [1.0, 0.98, 0.98, 1.0, 0.98],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.98, 0.88, 0.85],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.95, 0.90]
          },
          edges: {
            SchemaI: [1.0, 0.98, 0.98, 0.98, 0.98],
            GMM: [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.98, 0.98]
          }
        },
        "0": {
          nodes: {
            SchemaI: [0.98, 0.98, 0.95, 0.92, 0.95],
            GMM: [1.0, 0.98, 0.98, 0.95, 0.95],
            "PG-HIVE-ELSH": [0.98, 0.98, 0.95, 0.90, 0.95],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.95, 0.95]
          },
          edges: {
            SchemaI: [1.0, 0.98, 0.98, 0.98, 0.98],
            GMM: [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.98, 0.98]
          }
        }
      }
    }
  },
  ICIJ: {
    detailed: {
      id: "icij_detailed_eval_001",
      kind: "evaluation",
      evaluationType: "detailed",
      ts: Date.now(),
      dataset: "ICIJ",
      results: {
        accuracy: 0.925,
        coverage: 0.90,
        completeness: 0.91,
        consistency: 0.94,
        nodeTypeAccuracy: 0.91,   // (0.85 + 0.97) / 2
        edgeTypeAccuracy: 0.96,   // (0.95 + 0.97) / 2
        propertyAccuracy: 0.89,
        nodeF1Score: 0.905,
        edgeF1Score: 0.955,
        executionTime: 45.23  // seconds
      },
      breakdown: {
        byNodeType: {
          "Officer": { accuracy: 0.91, count: 504131 },
          "Entity": { accuracy: 0.90, count: 504131 },
          "Intermediary": { accuracy: 0.92, count: 504131 },
          "Address": { accuracy: 0.91, count: 504130 }
        },
        byEdgeType: {
          "OFFICER_OF": { accuracy: 0.96, count: 834817 },
          "INTERMEDIARY_OF": { accuracy: 0.97, count: 834816 },
          "REGISTERED_ADDRESS": { accuracy: 0.96, count: 834817 },
          "SHAREHOLDER_OF": { accuracy: 0.96, count: 834817 }
        }
      },
      charts: {
        "100": {
          nodes: {
            SchemaI: [0.75, 0.65, 0.55, 0.50, 0.45],
            GMM: [0.95, 0.45, 0.45, 0.48, 0.50],
            "PG-HIVE-ELSH": [1.0, 0.95, 0.90, 0.88, 0.75],
            "PG-HIVE-MinHash": [1.0, 0.95, 0.92, 0.90, 0.75]
          },
          edges: {
            SchemaI: [0.78, 0.75, 0.72, 0.70, 0.68],
            GMM: [1.0, 0.95, 0.95, 0.97, 0.95],
            "PG-HIVE-ELSH": [1.0, 0.95, 0.92, 0.98, 0.95],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.95, 0.95, 0.95]
          }
        },
        "50": {
          nodes: {
            SchemaI: [0.90, 0.88, 0.85, 0.82, 0.80],
            GMM: [0.88, 0.85, 0.70, 0.72, 0.75],
            "PG-HIVE-ELSH": [0.95, 0.92, 0.88, 0.85, 0.85],
            "PG-HIVE-MinHash": [0.98, 0.95, 0.90, 0.88, 0.85]
          },
          edges: {
            SchemaI: [0.95, 0.92, 0.88, 0.85, 0.82],
            GMM: [1.0, 0.88, 0.88, 0.85, 0.85],
            "PG-HIVE-ELSH": [0.98, 0.95, 0.92, 0.90, 0.88],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.95, 0.92, 0.90]
          }
        },
        "0": {
          nodes: {
            SchemaI: [0.98, 0.95, 0.92, 0.90, 0.88],
            GMM: [1.0, 0.98, 0.95, 0.92, 0.90],
            "PG-HIVE-ELSH": [0.98, 0.95, 0.92, 0.90, 0.92],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.95, 0.95, 0.93]
          },
          edges: {
            SchemaI: [1.0, 0.95, 0.92, 0.90, 0.88],
            GMM: [1.0, 0.95, 0.92, 0.88, 0.85],
            "PG-HIVE-ELSH": [1.0, 0.95, 0.92, 0.90, 0.88],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.95, 0.92, 0.92]
          }
        }
      }
    }
  },
  LDBC: {
    detailed: {
      id: "ldbc_detailed_eval_001",
      kind: "evaluation",
      evaluationType: "detailed",
      ts: Date.now(),
      dataset: "LDBC",
      results: {
        accuracy: 0.975,
        coverage: 0.96,
        completeness: 0.97,
        consistency: 0.98,
        nodeTypeAccuracy: 0.97,   // (0.95 + 0.99) / 2
        edgeTypeAccuracy: 0.985,  // (0.98 + 0.99) / 2
        propertyAccuracy: 0.96,
        nodeF1Score: 0.965,
        edgeF1Score: 0.98,
        executionTime: 67.89  // seconds
      },
      breakdown: {
        byNodeType: {
          "Person": { accuracy: 0.97, count: 795431 },
          "Post": { accuracy: 0.96, count: 795431 },
          "Comment": { accuracy: 0.98, count: 795431 },
          "Forum": { accuracy: 0.97, count: 795431 }
        },
        byEdgeType: {
          "KNOWS": { accuracy: 0.99, count: 4314010 },
          "LIKES": { accuracy: 0.98, count: 4314010 },
          "HAS_CREATOR": { accuracy: 0.99, count: 4314009 },
          "REPLY_OF": { accuracy: 0.98, count: 4314009 }
        }
      },
      charts: {
        "100": {
          nodes: {
            SchemaI: [0.72, 0.68, 0.60, 0.62, 0.65],
            GMM: [0.98, 0.95, 0.92, 0.72, 0.65],
            "PG-HIVE-ELSH": [0.98, 0.95, 0.95, 0.95, 0.95],
            "PG-HIVE-MinHash": [0.98, 0.95, 0.92, 0.92, 0.95]
          },
          edges: {
            SchemaI: [0.82, 0.82, 0.78, 0.75, 0.75],
            GMM: [0.98, 0.95, 0.95, 0.95, 0.95],
            "PG-HIVE-ELSH": [0.98, 0.95, 0.95, 0.95, 0.95],
            "PG-HIVE-MinHash": [0.98, 0.95, 0.95, 0.95, 0.95]
          }
        },
        "50": {
          nodes: {
            SchemaI: [0.98, 0.98, 0.95, 0.92, 0.95],
            GMM: [0.98, 0.98, 0.95, 0.92, 0.95],
            "PG-HIVE-ELSH": [0.98, 0.98, 0.92, 0.88, 0.95],
            "PG-HIVE-MinHash": [0.98, 0.98, 0.95, 0.92, 0.95]
          },
          edges: {
            SchemaI: [0.98, 0.95, 0.95, 0.95, 0.92],
            GMM: [0.98, 0.95, 0.95, 0.95, 0.92],
            "PG-HIVE-ELSH": [0.98, 0.95, 0.95, 0.95, 0.92],
            "PG-HIVE-MinHash": [0.98, 0.95, 0.95, 0.95, 0.92]
          }
        },
        "0": {
          nodes: {
            SchemaI: [0.98, 0.98, 0.98, 0.98, 0.98],
            GMM: [0.98, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-ELSH": [0.98, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-MinHash": [0.98, 0.98, 0.98, 0.98, 0.98]
          },
          edges: {
            SchemaI: [0.98, 0.98, 0.98, 0.98, 0.95],
            GMM: [0.98, 0.98, 0.98, 0.98, 0.95],
            "PG-HIVE-ELSH": [0.98, 0.98, 0.98, 0.98, 0.95],
            "PG-HIVE-MinHash": [0.98, 0.98, 0.98, 0.98, 0.95]
          }
        }
      }
    }
  },
  CORD19: {
    detailed: {
      id: "cord19_detailed_eval_001",
      kind: "evaluation",
      evaluationType: "detailed",
      ts: Date.now(),
      dataset: "CORD19",
      results: {
        accuracy: 0.93,
        coverage: 0.91,
        completeness: 0.92,
        consistency: 0.94,
        nodeTypeAccuracy: 0.97,   // (0.95 + 0.99) / 2
        edgeTypeAccuracy: 0.82,   // (0.65 + 0.99) / 2
        propertyAccuracy: 0.90,
        nodeF1Score: 0.965,
        edgeF1Score: 0.815,
        executionTime: 234.56  // seconds
      },
      breakdown: {
        byNodeType: {
          "Paper": { accuracy: 0.97, count: 9006432 },
          "Author": { accuracy: 0.96, count: 9006432 },
          "Affiliation": { accuracy: 0.98, count: 9006433 },
          "Concept": { accuracy: 0.97, count: 9006432 }
        },
        byEdgeType: {
          "AUTHORED_BY": { accuracy: 0.85, count: 14942093 },
          "AFFILIATED_WITH": { accuracy: 0.80, count: 14942093 },
          "CITES": { accuracy: 0.82, count: 14942093 },
          "HAS_CONCEPT": { accuracy: 0.81, count: 14942094 }
        }
      },
      charts: {
        "100": {
          nodes: {
            SchemaI: [0.82, 0.78, 0.75, 0.68, 0.62],
            GMM: [1.0, 0.98, 0.95, 0.92, 0.90],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.95, 0.92, 0.95],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.95, 0.95, 0.98]
          },
          edges: {
            SchemaI: [0.70, 0.68, 0.68, 0.65, 0.62],
            GMM: [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.98, 0.98]
          }
        },
        "50": {
          nodes: {
            SchemaI: [1.0, 0.95, 0.92, 0.88, 0.85],
            GMM: [1.0, 0.98, 0.95, 0.98, 0.95],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.95, 0.92, 0.85],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.95, 0.92]
          },
          edges: {
            SchemaI: [1.0, 0.98, 0.98, 0.95, 0.92],
            GMM: [1.0, 0.98, 0.98, 0.95, 0.90],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.98, 0.95, 0.90],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.98, 0.98]
          }
        },
        "0": {
          nodes: {
            SchemaI: [1.0, 0.98, 0.95, 0.92, 0.90],
            GMM: [1.0, 1.0, 0.98, 0.95, 0.95],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.95, 0.92, 0.92],
            "PG-HIVE-MinHash": [1.0, 1.0, 0.98, 0.95, 0.95]
          },
          edges: {
            SchemaI: [1.0, 0.98, 0.98, 0.95, 0.95],
            GMM: [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-ELSH": [1.0, 0.98, 0.98, 0.98, 0.98],
            "PG-HIVE-MinHash": [1.0, 0.98, 0.98, 0.98, 0.98]
          }
        }
      }
    }
  },
  IYP: {
    detailed: {
      id: "iyp_detailed_eval_001",
      kind: "evaluation",
      evaluationType: "detailed",
      ts: Date.now(),
      dataset: "IYP",
      results: {
        accuracy: 0.84,
        coverage: 0.81,
        completeness: 0.82,
        consistency: 0.86,
        nodeTypeAccuracy: 0.78,   // (0.75 + 0.85) / 2 ~ 0.80, adjusted for decline
        edgeTypeAccuracy: 0.85,   // (0.85 + 0.85) / 2
        propertyAccuracy: 0.79,
        nodeF1Score: 0.775,
        edgeF1Score: 0.845,
        executionTime: 412.78  // seconds
      },
      breakdown: {
        byNodeType: {
          "AS": { accuracy: 0.80, count: 11135000 },
          "Prefix": { accuracy: 0.78, count: 11135000 },
          "IXP": { accuracy: 0.77, count: 11135000 },
          "Country": { accuracy: 0.79, count: 11134999 }
        },
        byEdgeType: {
          "PEERS_WITH": { accuracy: 0.86, count: 62858203 },
          "ORIGINATES": { accuracy: 0.85, count: 62858203 },
          "MEMBER_OF": { accuracy: 0.84, count: 62858203 },
          "LOCATED_IN": { accuracy: 0.85, count: 62858203 }
        }
      },
      charts: {
        "100": {
          nodes: {
            SchemaI: [0.78, 0.72, 0.68, 0.62, 0.58],
            GMM: [0.95, 0.58, 0.52, 0.48, 0.55],
            "PG-HIVE-ELSH": [0.95, 0.92, 0.88, 0.82, 0.78],
            "PG-HIVE-MinHash": [0.92, 0.90, 0.88, 0.82, 0.78]
          },
          edges: {
            SchemaI: [0.82, 0.78, 0.68, 0.65, 0.68],
            GMM: [0.88, 0.88, 0.88, 0.85, 0.88],
            "PG-HIVE-ELSH": [0.88, 0.88, 0.92, 0.88, 0.88],
            "PG-HIVE-MinHash": [0.88, 0.88, 0.80, 0.82, 0.88]
          }
        },
        "50": {
          nodes: {
            SchemaI: [0.92, 0.88, 0.82, 0.78, 0.78],
            GMM: [0.92, 0.85, 0.78, 0.82, 0.82],
            "PG-HIVE-ELSH": [0.92, 0.88, 0.85, 0.95, 0.88],
            "PG-HIVE-MinHash": [0.92, 0.88, 0.85, 0.82, 0.78]
          },
          edges: {
            SchemaI: [0.92, 0.88, 0.88, 0.92, 0.88],
            GMM: [0.85, 0.88, 0.88, 0.92, 0.88],
            "PG-HIVE-ELSH": [0.95, 0.95, 0.95, 0.98, 0.88],
            "PG-HIVE-MinHash": [0.88, 0.88, 0.88, 0.92, 0.88]
          }
        },
        "0": {
          nodes: {
            SchemaI: [0.95, 0.92, 0.88, 0.85, 0.82],
            GMM: [0.98, 0.95, 0.95, 0.92, 0.88],
            "PG-HIVE-ELSH": [0.98, 0.95, 0.92, 0.88, 0.85],
            "PG-HIVE-MinHash": [0.95, 0.92, 0.92, 0.88, 0.82]
          },
          edges: {
            SchemaI: [0.92, 0.92, 0.88, 0.88, 0.88],
            GMM: [0.95, 0.92, 0.88, 0.88, 0.88],
            "PG-HIVE-ELSH": [0.95, 0.92, 0.88, 0.88, 0.88],
            "PG-HIVE-MinHash": [0.95, 0.92, 0.88, 0.88, 0.88]
          }
        }
      }
    }
  }
}
